import { toLocationGroupAddressInput } from './address-form-rules.js';
/** Omits `name`: a dialog with no name field would write back the one it captured at mount. */
export function toAddLocationGroupAddressInput(values) {
    return { address: toLocationGroupAddressInput(values) };
}
//# sourceMappingURL=to-add-address-input.js.map